import { useCallback, useEffect, useState } from "react";
import { useOnUpdateUserEvents } from "../../../hooks/firestoreHooks/eventListUpdateHook";
import { useAppDispatch } from "../../../hooks/storeHooks";
import { ROUTE_QUERY_CONSTANTS } from "../../../routes";
import {
  getEventsThunk,
} from "../../../store/events/eventThunk";
import { EVENT_TYPE } from "../../../types/eventTypes";
import EventGrid from "../EventGrid";
const Approved = () => {
  const dispatch = useAppDispatch();
  const [shouldStartUpdating, setShouldStartUpdating] = useState(false);

  const fetchEventListData = useCallback(async () => {
    dispatch(
      getEventsThunk({
        type: EVENT_TYPE.APPROVED,
        isLoading: false,
      })
    );
  }, [dispatch]);

  useOnUpdateUserEvents(shouldStartUpdating, fetchEventListData);

  useEffect(() => {
    const getData = async () => {
      await dispatch(
        getEventsThunk({
          type: EVENT_TYPE.APPROVED,
          isLoading: true,
        })
      );
      setShouldStartUpdating(true);
    };
    getData();
  }, []);
  return (
    <EventGrid
      gridId={`EVENT_APPROVED`}
      eventType={"APPROVED"}
      showSave={false}
      title={"Approved Events"}
      queryParams={ROUTE_QUERY_CONSTANTS.Approved}
    />
  );
};

export default Approved;
